// extracted by mini-css-extract-plugin
export default {"formAdd":"styles_formAdd__UbKgf","formItem":"styles_formItem__hJuq6","formFull":"styles_formFull__KQ8eC","InputNumber":"styles_InputNumber__mx11K"};